import React, { useEffect, useState } from "react";
import { login } from "./Apis/api";
import { useNavigate, Link } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const history = useNavigate();

  useEffect(() => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("token") != null
    ) {
      // Redirect to the home page
      history("/login");
      localStorage.removeItem("token");

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      //   const response = await axios.post("/login", { phoneNumber, password });
      const response = await login(phoneNumber, password);
      localStorage.setItem("token", response.data.payload.token);


      // Redirect to the home page
      history("/home");

      // Do something with the response, such as storing tokens or redirecting to a new page
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message);
      } else {
        setError("An error occurred during sign in.");
      }
    }
  };
  return (
    <div 
      className="d-flex align-items-center justify-content-center" 
      style={{ minHeight: "100vh", padding: "20px", marginTop: "-55px" }}
    >
      <div 
        className="glass-card" 
        style={{ width: "100%", maxWidth: "420px", padding: "40px 30px" }}
      >
        <div className="text-center mb-4">
          <div 
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              background: "linear-gradient(135deg, var(--primary) 0%, var(--success) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginBottom: "8px"
            }}
          >
            My Money
          </div>
          <p style={{ color: "var(--text-secondary)", fontSize: "0.95rem" }}>
            Track and optimize your personal wealth
          </p>
        </div>

        {error && (
          <div 
            className="alert alert-danger" 
            style={{ 
              borderRadius: "12px", 
              backgroundColor: "rgba(239, 68, 68, 0.1)", 
              border: "1px solid rgba(239, 68, 68, 0.2)", 
              color: "var(--danger)",
              fontSize: "0.9rem" 
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSignIn}>
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              id="phoneNumber"
              placeholder=" "
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
            <label htmlFor="phoneNumber">Phone Number</label>
          </div>
          <div className="form-floating mb-4 position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              id="password"
              placeholder=" "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
            <div 
              className="position-absolute" 
              style={{ top: "50%", right: "15px", transform: "translateY(-50%)", cursor: "pointer", zIndex: 10, color: "var(--text-secondary)" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </div>
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100 mb-3" 
            style={{ padding: "12px", fontSize: "1rem", fontWeight: "600" }}
          >
            Sign In
          </button>

          <div className="text-center">
            <span style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
              Don't have an account?{" "}
            </span>
            <Link 
              to="/signup" 
              style={{ 
                color: "var(--primary)", 
                textDecoration: "none", 
                fontWeight: "600",
                fontSize: "0.9rem" 
              }}
            >
              Sign Up
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
